<template>
  <module-list-layout :createAction="createAction" :module="module" class="p-2" v-if="amReady">
    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
      <moduleForm
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          formTitle="Add voip testing panel user setting"
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :profilesList="profilesList"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <div class="p-3">
      <div class="row">
        <div class="col-12 col-md-6 pt-2">
          <span class="ag-grid-quick-search-label">Search</span>
          <span><el-input class="d-inline-block w-50" v-model="userSearch" size='mini'></el-input></span>
        </div>
        <div class="col-12 col-md-6">
          <pagination
              :currentPage="currentPage"
              paginateClass=""
              :page-count="getPagesCount()"
              :page-range="4"
              :margin-pages="2"
              :navigateHandler="navigateToPage"></pagination>
        </div>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </module-list-layout>
</template>

<script>
import Vue from 'vue'
import {AgGridVue} from 'ag-grid-vue';
import actionsCell from './ag-grid/ActionsCell'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'
import {mapActions} from "vuex";

export default {
  watch: {
    userSearch: function (val) {
      this.agGrid.gridApi.setQuickFilter(val);
    }
  },
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  data() {
    return {
      amReady: false,
      module: {
        ...module
      },
      userSearch: null,
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'dialcode',
            headerName: 'Dialcode',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'destination',
            headerName: 'Destination',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 80,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: Vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityList({page: this.currentPage}).then(response => {
      this.agGrid.rowData = response.rows;
      this.recordsCounter = response.count;
      this.amReady = true
    })
  },
  methods: {
    ...mapActions('voip-testing-panel-user-setting-api', {getEntityList: 'list'}),
    scrollToTop () {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount () {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage (page) {
      $router.push({name : 'module->voip-testing-panel-user-setting->list->page', params: {listPage: page}})
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
